// extracted by mini-css-extract-plugin
export var bounce = "_i0-1";
export var generatingText = "_i0-6";
export var lightning = "_i0-4";
export var popup = "_i0-5";
export var progressBar = "_i0-7";
export var progressFill = "_i0-8";
export var progressShimmer = "_i0-9";
export var progressText = "_i0-a";
export var shimmer = "_i0-3";
export var uploadIcon = "_i0-0";
export var uploadingText = "_i0-2";